// Renders the Google Identity Services button and forwards the ID token to auth.
import { useEffect, useRef } from "react";
import { useAuth } from "@/features/auth/AuthContext";

interface GoogleAccounts {
  accounts: {
    id: {
      initialize: (cfg: { client_id: string; callback: (r: { credential: string }) => void }) => void;
      renderButton: (el: HTMLElement, opts: Record<string, unknown>) => void;
    };
  };
}

declare global {
  interface Window {
    google?: GoogleAccounts;
  }
}

const CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID ?? "";

export function GoogleSignInButton() {
  const ref = useRef<HTMLDivElement>(null);
  const { login } = useAuth();

  useEffect(() => {
    if (!CLIENT_ID) return;
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.onload = () => {
      window.google?.accounts.id.initialize({
        client_id: CLIENT_ID,
        callback: (resp) => void login(resp.credential),
      });
      if (ref.current) {
        window.google?.accounts.id.renderButton(ref.current, {
          theme: "filled_black",
          shape: "pill",
          size: "large",
        });
      }
    };
    document.body.appendChild(script);
    return () => script.remove();
  }, [login]);

  if (!CLIENT_ID) {
    return <p className="text-sm opacity-70">Set VITE_GOOGLE_CLIENT_ID to enable sign-in.</p>;
  }
  return <div ref={ref} />;
}
